export const ROLES = {
  Facilitator: 'Facilitator',
  CountyCoordinator: 'County Coordinator',
  RegionalCountyCoordinator: 'Regional County Coordinator',
  SiteCoordinator: 'Site Coordinator',
  FinanceOfficer: 'Finance Officer',
  Admin: 'Admin',
  SuperAdmin: 'Super Admin',
  Director: 'Director',
  ClusterLeader: 'Cluster Leader',
  Data: 'Data',
  CheaqueApprover1: 'CheaqueApprover1',
  CheaqueApprover2: 'CheaqueApprover2',
  DataValidator: 'DataValidator',
};

export const allowedEmails = ['aocalo@shofco.org', 'rotieno@shofco.org', 'bawuor@shofco.org', 'condiek@shofco.org']

